import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from "@/api/PMS/baseInformation/building";
import { fetchListByType } from "@/api/PMS/dic/dic";
import waves from "@/directive/waves"; // 水波纹指令

import buildingAdd from "./add";
import unitAdd from "../buildingUnit/add";
import houseAdd from "../house/add";
import advAdd from "../advertising/add";
import parkAdd from "../pakinglotoa/add";
import buildingDetail from "./detail"; // 导入弹出框

import importExcel from "./import"; // 导出

import { formatJson } from "@/utils/index";
export default {
  components: {
    buildingAdd: buildingAdd,
    buildingDetail: buildingDetail,
    unitAdd: unitAdd,
    houseAdd: houseAdd,
    advAdd: advAdd,
    parkAdd: parkAdd,
    importExcel: importExcel
  },
  directives: {
    waves: waves
  },
  props: ["routerIdArr", "id", "flagId", "activeName", "isInitSearch"],
  data: function data() {
    return {
      isDetail: false,
      downloadLoading: false,
      list: null,
      total: null,
      listLoading: false,
      initSearch: this.isInitSearch,
      listQuery: {
        page: 1,
        limit: 10,
        buildingName: "",
        buildingOrder: "",
        buildingType: "",
        buildingUse: "",
        buildingToward: ""
      },
      title: "",
      buildingId: "",
      multipleSelection: [],
      typeOption: [],
      useOption: [],
      towardOption: [],
      dialogFormVisible: false,
      dialogDetailVisible: false,
      dialogUnitVisible: false,
      dialogHouseVisible: false,
      dialogAdvVisible: false,
      dialogParkVisible: false,
      // 导入
      dialogExcelVisible: false,
      exLists: [],
      slist: []
    };
  },
  watch: {
    id: function id(val) {
      this.getList();
    },
    flagId: function flagId(val) {
      this.getList();
    },
    activeName: function activeName(val) {
      this.getList();
    }
  },
  created: function created() {
    this.getList();
    this.loadTypeOptions();
    this.loadUseOptions();
    this.loadTowardOptions();
  },
  methods: _defineProperty({
    handleDeletes: function handleDeletes() {
      var buildingIds = [];
      this.multipleSelection.forEach(function (row) {
        buildingIds.push(row.buildingId);
      });
      this.delete(buildingIds);
    },
    handCancle: function handCancle(reload) {
      this.$emit("refreshTree");
      this.$emit("loadMenuTab");

      switch (reload) {
        case true:
          this.getList();
          this.dialogFormVisible = false;
          this.dialogUnitVisible = false;
          this.dialogHouseVisible = false;
          this.dialogAdvVisible = false;
          this.dialogParkVisible = false;
          break;

        case "buildingAdd":
          this.dialogFormVisible = false;
          break;

        case "unitAdd":
          this.dialogUnitVisible = false;
          break;

        case "offHouseEdit":
          this.dialogHouseVisible = false;
          break;

        case "offAdvertisingEdit":
          this.dialogAdvVisible = false;
          break;

        case "offParkAdd":
          this.dialogParkVisible = false;
          break;
      }
    },
    handDetailCancle: function handDetailCancle(data) {
      this.dialogDetailVisible = false;

      switch (data) {
        case "edit":
          this.title = "编辑";
          this.dialogFormVisible = true;
          break;

        case "unit":
          this.buildingId = "";
          this.title = "添加单元";
          this.dialogUnitVisible = true;
          break;

        case "house":
          this.buildingId = "";
          this.title = "添加房间";
          this.dialogHouseVisible = true;
          break;

        case "adv":
          this.buildingId = "";
          this.title = "添加广告位";
          this.dialogAdvVisible = true;
          break;

        case "park":
          this.buildingId = "";
          this.title = "添加停车位";
          this.dialogParkVisible = true;
          break;
      }
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.listQuery.dataType = this.flagId;
      this.listQuery.id = this.id;

      if (this.initSearch === true) {
        this.listQuery.buildingName = "";
        this.listQuery.buildingOrder = "";
        this.listQuery.buildingType = "";
        this.listQuery.buildingUse = "";
        this.listQuery.buildingToward = "";
      }

      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    getItemDetail: function getItemDetail(buildingId) {
      this.buildingId = buildingId;
      this.title = "详情";
      this.dialogDetailVisible = true;
    },
    handleFilter: function handleFilter() {
      this.initSearch = false;
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.initSearch = false;
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.initSearch = false;
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.initSearch = false;
      this.multipleSelection = val;
    },
    loadTypeOptions: function loadTypeOptions() {
      var _this2 = this;

      fetchListByType("building_type").then(function (r) {
        _this2.typeOption = r.data.data;
      });
    },
    loadUseOptions: function loadUseOptions() {
      var _this3 = this;

      fetchListByType("building_use").then(function (r) {
        _this3.useOption = r.data.data;
      });
    },
    loadTowardOptions: function loadTowardOptions() {
      var _this4 = this;

      fetchListByType("building_toward").then(function (r) {
        _this4.towardOption = r.data.data;
      });
    },
    // 创建
    handleCreate: function handleCreate() {
      this.buildingId = "";
      this.title = "添加";
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(buildingId) {
      this.buildingId = buildingId;
      this.title = "编辑";
      this.dialogFormVisible = true;
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    delete: function _delete(buildingIds) {
      var _this5 = this;

      if (buildingIds.length > 0) {
        this.$confirm("你确定是要删除这些楼宇, 是否继续?", "提示").then(function () {
          fetchDelete(buildingIds).then(function (response) {
            if (response.data.code == 200) {
              _this5.getList();

              _this5.$emit("refreshTree");

              _this5.$emit("loadMenuTab");

              _this5.Alert({
                alertType: "delete"
              });
            } else {
              _this5.Alert({
                alertType: "error",
                message: response.data.message
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: "nodata"
        });
      }
    },
    handleDelete: function handleDelete(buildingId) {
      var buildingIds = [];
      buildingIds.push(buildingId);
      this.delete(buildingIds);
    },
    // 导出
    handleExport: function handleExport() {
      var _this6 = this;

      this.exLists = [];
      var exList = {
        buildingName: this.listQuery.buildingName,
        buildingOrder: this.listQuery.buildingOrder,
        buildingType: this.listQuery.buildingType,
        buildingUse: this.listQuery.buildingUse,
        buildingToward: this.listQuery.buildingToward,
        dataType: this.listQuery.dataType,
        id: this.listQuery.id
      };
      fetchList(exList).then(function (response) {
        response.data.data.forEach(function (v, index) {
          _this6.exLists.push({
            indexs: index + 1,
            areaGroupName: v.areaGroupName,
            buildingName: v.buildingName,
            buildingFloors: v.buildingFloors,
            buildingTypeName: v.buildingTypeName,
            buildingUseName: v.buildingUseName,
            buildingTowardName: v.buildingTowardName,
            buildingRemark: v.buildingRemark
          });
        }); // this.exLists = response.data.data;
      });
      this.$confirm("你确定要导出楼栋数据吗, 是否继续?", "提示").then(function () {
        if (_this6.exLists !== null && _this6.exLists.length > 0) {
          Promise.resolve().then(function () {
            return _interopRequireWildcard(require("@/vendor/Export2Excel"));
          }).then(function (excel) {
            var tHeader = ["序号", "管理区域", "楼栋", "层数", "类型", "用途", "朝向", "说明"];
            var fileterVal = ["indexs", "areaGroupName", "buildingName", "buildingFloors", "buildingTypeName", "buildingUseName", "buildingTowardName", "buildingRemark"];
            var data = formatJson(fileterVal, _this6.exLists);
            excel.export_json_to_excel({
              header: tHeader,
              data: data,
              filename: "楼栋数据",
              autoWidth: true,
              bookType: "xlsx"
            });
          });
        } else {
          _this6.Alert({
            alertType: "error",
            message: "暂无数据，无法导出！"
          });
        }
      });
    },
    // 导入
    handleUpload: function handleUpload() {
      this.title = "导入Excel";
      this.dialogExcelVisible = true;
    }
  }, "handCancle", function handCancle() {
    this.dialogExcelVisible = false;
    this.dialogFormVisible = false;
    this.getList();
    this.$emit('loadMenuTab');
  })
};